import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

const DEF = { enabled: true, title: "Limited-time credit sale", message: "Save up to {percent}% on AI credit top-ups.", cta_label: "View offers", show_on: ["dashboard"] };
const PLACES = [["home", "Before login (sign-in & sign-up pages)"], ["dashboard", "After login (dashboard)"]];

export default function SaleBannerEditor({ value }) {
  const [b, setB] = useState({ ...DEF, ...(value || {}) });
  const [busy, setBusy] = useState(false);
  const tog = (k) => setB({ ...b, show_on: b.show_on.includes(k) ? b.show_on.filter((x) => x !== k) : [...b.show_on, k] });
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/admin/config", { sale_banner: b }); setB({ ...DEF, ...r.data.sale_banner }); toast.success("Sale banner saved"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="lx-card space-y-3 lg:col-span-3" data-testid="admin-sale-banner">
      <div className="flex items-center justify-between gap-3">
        <div><div className="font-semibold">Credit sale banner</div><p className="text-xs text-slate-500">Shown automatically only while a top-up pack sale is running, with a countdown to the earliest sale end. Use {"{percent}"} in the message for the biggest saving.</p></div>
        <label className="flex items-center gap-2 text-sm"><Switch checked={b.enabled} onCheckedChange={(v) => setB({ ...b, enabled: v })} data-testid="admin-sale-banner-enabled" />Enabled</label>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
        <label className="space-y-1">Title<Input value={b.title} maxLength={80} onChange={(e) => setB({ ...b, title: e.target.value })} data-testid="admin-sale-banner-title" /></label>
        <label className="space-y-1">Message<Input value={b.message} maxLength={200} onChange={(e) => setB({ ...b, message: e.target.value })} data-testid="admin-sale-banner-message" /></label>
        <label className="space-y-1">Button text<Input value={b.cta_label} maxLength={30} onChange={(e) => setB({ ...b, cta_label: e.target.value })} data-testid="admin-sale-banner-cta" /></label>
      </div>
      <div className="flex flex-wrap gap-4 text-sm">
        <span className="text-slate-500">Show on:</span>
        {PLACES.map(([k, l]) => <label key={k} className="flex items-center gap-1.5"><input type="checkbox" checked={b.show_on.includes(k)} onChange={() => tog(k)} data-testid={`admin-sale-banner-show-${k}`} />{l}</label>)}
      </div>
      <Button size="sm" onClick={save} disabled={busy} data-testid="admin-sale-banner-save">{busy ? "Saving..." : "Save banner"}</Button>
    </div>
  );
}
